import React, { useState, useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//icons
import { BiCalendarCheck } from 'react-icons/bi';
import { MdPlace } from 'react-icons/md';
// api
import { getDetailSchedule, getAllRelatedSchedule } from 'api/company';
//helpers
import { convertDateToDDMMYYYY } from 'helpers';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import CardEvent from 'components/event/cardEvent';
import Head from 'components/metatags_helmet/metatags';
//styles
import './schedule.scss';

const EventDetail = () => {
  const navigate = useNavigate();
  const [item, setItem] = useState([]);
  const [relatedEvents, setRelatedEvents] = useState([])
  const params = useParams();
  const { t } = useTranslation(['schedule']);
  const { assignedLibrary } = useAssignedLibrary();

  useEffect(() => {
    const getActivity = async () => {
      const rs = await getDetailSchedule(params.id);
      if (rs.status === 200) {

        setItem(rs?.data);
      }
    };
    const goUp = () => {
      window.scrollTo(0, 0);
    };
    const getRelatedSchedule = async () => {
      try {
        const { data, status } = await getAllRelatedSchedule(params.id)
        if (status === 200) {
          setRelatedEvents(data)
        }
      } catch (error) {
        console.log(error)
      }
    }
    goUp();
    getActivity();
    getRelatedSchedule()
  }, [params.id]);


  const capitalizeFirstLetter = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  const getTag = (tag) => {
    navigate(`/${assignedLibrary}/agenda?tags=${tag}`, { replace: true });
  }

  return (
    <div className="container-fluid px-0 mainDiv py-4">
      <Head description={'Libelista'} title={'Libelista'} />
      <Row className="px-2 mx-0 d-flex">
        <Col md={6} className="pl-1">
          <img
            src={`${item?.image}`}
            alt={`${item?.title || t('imageactivity')}`} className="width-95-percentage"
          />
        </Col>
        <Col md={6}>
          <h1 className="page-title static-title mt-4 openSansItalic">
            {item.title}
          </h1>
          <h6 className="mb-2 text-muted orange text-uppercase">
            {item?.type_schedule?.name}
          </h6>
          {(item.start_date && item.end_date) && (
            <div className="d-flex mt-5 align-items-center">
              <BiCalendarCheck className="orange font-size-mobile" size={30} />
              <span className="mx-2 font-weight-bold font-size-mobile">{convertDateToDDMMYYYY(item.start_date)} {t('toThe')} {convertDateToDDMMYYYY(item.end_date)}</span>
            </div>
          )}

          {(item?.place && item.place !== 'null') &&
            <div className="d-flex align-items-center mt-2">
              <MdPlace className="orange font-size-mobile" size={30} />
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.place)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2 text-uppercase font-weight-bold font-size-mobile no-underline"
              >
                {item.place}
              </a>
            </div>
          }
          <div className="container-tags">
            {
              item?.tag_list && item?.tag_list?.map((item) => (
                <span className="container-tags__item cursor-pointer" onClick={() => getTag(item)}>
                  {capitalizeFirstLetter(item)}
                </span>
              ))
            }
          </div>
        </Col>
      </Row>
      <Container fluid className="px-0 mx-0 eventDetail ">
        <Row className="pl-3 mx-0 mt-4">
          <Col md={12}>
            <div className="eventDetail-body " dangerouslySetInnerHTML={{ __html: item.body }} />
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          {relatedEvents.length > 0 && (
            <>
              <h1 className="page-title static-title openSansItalic mt-5">
                {t('relatedevents')}
              </h1>
              {relatedEvents.map((element) => (
                <Col md={4} className="mt-3" key={element.id}>
                  <CardEvent event={element} />
                </Col>
              ))}
            </>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default EventDetail;
